import { useLocation, Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Home } from "lucide-react";

// Route metadata mapping
const routeLabels: Record<string, string> = {
  dashboard: "Dashboard",
  accounting: "Accounting",
  pl: "P&L",
  "cash-flow": "Cash Flow",
  "balance-sheet": "Balance Sheet",
  "tax-center": "Tax Center",
  reconciliation: "Reconciliation",
  finance: "Finance",
  bank: "Bank",
  sales: "Sales",
  expenses: "Expenses",
  operations: "Operations",
  inventory: "Inventory",
  menu: "Menu",
  vendors: "Vendors",
  "data-center": "Data Center",
  "sales-deposits": "Sales & Deposits",
  "sales-quantities": "Sales Quantities",
  receipts: "Receipt Uploads",
  settings: "Settings",
  admin: "Admin",
  companies: "Companies",
  users: "Users",
  packages: "Packages",
  "payroll-inbox": "Payroll Inbox",
  notifications: "Notifications",
};

export function DynamicBreadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  // Build breadcrumb items
  const breadcrumbItems = pathSegments.map((segment, index) => {
    const path = "/" + pathSegments.slice(0, index + 1).join("/");
    const label = routeLabels[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);
    const isLast = index === pathSegments.length - 1;

    return {
      path,
      label,
      isLast,
    };
  });

  // Don't show breadcrumbs on the main dashboard page
  if (location.pathname === "/dashboard") {
    return null;
  }

  return (
    <div className="border-b bg-card px-6 py-3">
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/dashboard" className="flex items-center gap-1.5">
                <Home className="h-4 w-4" />
                Dashboard
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          
          {breadcrumbItems.length > 1 && breadcrumbItems.map((item, index) => {
            // Skip the first "dashboard" segment as it's already shown as home
            if (item.path === "/dashboard") return null;

            return (
              <div key={item.path} className="flex items-center gap-1.5">
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  {item.isLast ? (
                    <BreadcrumbPage>{item.label}</BreadcrumbPage>
                  ) : (
                    <BreadcrumbLink asChild>
                      <Link to={item.path}>{item.label}</Link>
                    </BreadcrumbLink>
                  )}
                </BreadcrumbItem>
              </div>
            );
          })}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
}
